import { redirect, useActionData, useParams, useRevalidator, useRouteLoaderData, useSubmit } from "react-router-dom";
import ModalUrlWindow from "../../../../components/modalUrl";
import api from "../../../../hooks/useApi";
import jsonToFormData from "../../../../hooks/jsonToFormData";
import { Autoform } from "../../../../components/forms/autoform";
import { useForm } from "react-hook-form";
import { Alert } from "@mui/material";
import PageTitle from "../../../../components/PageTitle";

export async function action({ request, params }) {
    const id = params.object_id;
    const children_id = params.children_id;
    const formData = await request.formData();
    //console.log({ formData, id });

    try {
        const response = await api.patch(`/api/HotelObjChildren/${children_id}/`, formData)
        return redirect(`/object/${id}/children`);
    }
    catch (e) {
        return e;
    }
    return { status: 400, statusText: 'not ok', message: 'not patched!' }
}

export default function ChildrenObjEditField() {
    const { children_id, field_name, object_id } = useParams();
    const submit = useSubmit();
    const hotelObj = (useRouteLoaderData('obj_layout')).hotelObj
    const childrenForms = hotelObj.children_forms;
    const form = childrenForms[children_id];
    const formHook = useForm();
    const actionData = useActionData()
    const revalidator = useRevalidator();
    

    const handleSubmitForm = (data) => {
        const formData = jsonToFormData(data);
        submit(formData, {
            method: 'post',
            encType: 'multipart/form-data'
        })
    }
    const fields = {}
    fields[field_name] = form[field_name]
    //console.log(fields);

    return (
        <ModalUrlWindow
            url={`/object/${object_id}/children`}
            title={{ text: "Змінити інформацію про підоб'єкт" }}
            width='md'
        >
            <PageTitle title={`Редагування підоб'єкта: ${children_id || "ID"}`} />
            <Autoform
                formHook={formHook}
                fields={fields}
                onSubmit={handleSubmitForm}
                formName='HotelObjChildren'
                revalidator={revalidator}
            />
            {actionData?.response && (
                <Alert severity='error'>
                    {JSON.stringify(actionData.response)}
                </Alert>
            )}
        </ModalUrlWindow>
    )
}
